export default __webpack_public_path__ + "static/media/logo.e4d8db07.svg";